export const DEFAULT_CUSTOMER = 'DEFAULT_CUSTOMER' as const;
export const COMPANY_INFO = 'COMPANY_INFO' as const;
export const CURRENCIES = 'CURRENCIES' as const;
export const ADDRESS_TYPES = 'ADDRESS_TYPES' as const;
export const PERSON_TITLES = 'PERSON_TITLES' as const;
export const JOB_TITLES = 'JOB_TITLES' as const;
export const CUSTOMER_GROUPS = 'CUSTOMER_GROUPS' as const;
export const PRODUCT_GROUPS = 'PRODUCT_GROUPS' as const;
export const VAT_RATES = 'VAT_RATES' as const;
export const PRODUCT_UNITS = 'PRODUCT_UNITS' as const;
export const GIFT_CARD_TYPES = 'GIFT_CARD_TYPES' as const;
export const REGULAR_GIFT_CARDS = 'REGULAR_GIFT_CARDS' as const;
export const REASON_CODES = 'REASON_CODES' as const;
export const SERVICE_ENDPOINTS = 'SERVICE_ENDPOINTS' as const;
export const PAYMENT_TYPES = 'PAYMENT_TYPES' as const;
export const STORE_REGION = 'STORE_REGION' as const;
export const HOME_STORES = 'HOME_STORES' as const;
export const ASSORTMENT_PRODUCTS = 'ASSORTMENT_PRODUCTS' as const;
export const WAREHOUSES = 'WAREHOUSES' as const;
export const CAFA_CONFIGS_COMPANY = 'CAFA_CONFIGS_COMPANY' as const;
export const CAFA_CONFIGS_WAREHOUSE = 'CAFA_CONFIGS_WAREHOUSE' as const;
export const CAFA_CONFIGS_POS = 'CAFA_CONFIGS_POS' as const;
export const CAFA_CONFIGS_USER = 'CAFA_CONFIGS_USER' as const;
